export const sortArray = <T>(array: T[], field: keyof T, desc: boolean, abs = false) => {
  return array.sort((a, b): number => {
    if (typeof a[field] === "string" || typeof b[field] === "string") {
      const columnA = a[field] as string;
      const columnB = b[field] as string;
      return desc ? columnB.localeCompare(columnA) : columnA.localeCompare(columnB);
    }

    if (typeof a[field] === "number" || typeof b[field] === "number") {
      if (typeof a[field] !== "number") {
        return desc ? 1 : -1;
      }
      if (typeof b[field] !== "number") {
        return desc ? -1 : 1;
      }
      let columnA = a[field] as number;
      let columnB = b[field] as number;
      if (abs) {
        columnA = Math.abs(a[field] as number);
        columnB = Math.abs(b[field] as number);
      }
      return desc ? columnB - columnA : columnA - columnB;
    }

    if (typeof a[field] === "boolean" || typeof b[field] === "boolean") {
      return a[field] && desc ? 1 : a[field] ? -1 : 1;
    }

    return 0;
  });
};
